import { deleteEmptyObj, formatCST } from '@/utils/utils'

// 直辖市
const SPECIAL_CITY_MAP = ['北京', '天津', '上海', '重庆'].reduce((prev, next) => {
  const value = `${next}市`
  prev[next] = value
  prev[value] = value
  return prev
}, {})

const state = {
  increaseBoard: {
    studentNum: '',
    classNum: ''
  },
  teacherCharts: [],
  classCharts: [],
  studentGrowthCharts: [],
  workAverageCharts: [],
  studentsWorkCharts: [],
  studentCompareCharts: [],
  cityWorksCharts: [],
  mapName: {},
  page: 1,
  limit: 10,
  activeTab: '0',
  schoolId: '',
  schoolName: '',
  teacherName: '',
  area: [],
  created_at_from: null,
  created_at_to: null,
  sort_type: '',
  activeArea: {},
  cityActiveCharts: [],
  cityActiveNav: [{ name: '中国', id: '156' }],
  activeSchool: [],
  activeSchoolLoading: false,
  activeTeacher: [],
  activeTeacherLoading: false,
  activeStudent: [],
  activeStudentLoading: false,
  goodWork: [],
  goodWorkLoading: false,
  isServerTime: false, // 服务器统计数据时间为晚上12点-12点15分
  isDistrict: false,
  // 常量
  SPECIAL_CITY_MAP
}

const actions = {
  // 获取当前用户查看数据的权限
  async getSearchScope ({ commit }) {
    const res = await API.get('/edu/zone/region/range')
    commit('setState', {
      module: 'dataGraph',
      key: 'mapName',
      value: res.data
    })
    const time = Number(window.moment(res.headers.date).format('HHmmss'))
    if (time >= 0 && time <= 1459) {
      commit('setState', {
        module: 'dataGraph',
        key: 'isServerTime',
        value: true
      })
    }
    return res
  },
  // 获取学校/教师数据
  async dataGraphTableGetData ({ state, commit }) {
    const data = {
      id: state.schoolId,
      name: state.schoolName,
      real_name: state.teacherName,
      sort_type: state.sort_type,
      country_id: '156',
      province_id: state.area[0],
      city_id: state.area[1],
      district_id: state.area[2],
      created_at_from: state.created_at_from && formatCST(state.created_at_from),
      created_at_to: state.created_at_to && formatCST(state.created_at_to)
    }
    deleteEmptyObj(data)
    const url = state.activeTab === '0' ? '/edu/zone/statistics/unit/list' : '/edu/zone/statistics/teacher/list'
    const res = await API.post(`${url}?page=${state.page}&limit=${state.limit}`, data)
    return res
  },
  // 下载学校/教师数据
  async dataGraphTableDownload ({ state }) {
    const data = {
      id: state.schoolId,
      name: state.schoolName,
      real_name: state.teacherName,
      sort_type: state.sort_type,
      country_id: '156',
      province_id: state.area[0],
      city_id: state.area[1],
      district_id: state.area[2],
      created_at_from: state.created_at_from && formatCST(state.created_at_from),
      created_at_to: state.created_at_to && formatCST(state.created_at_to)
    }
    deleteEmptyObj(data)
    const url = state.activeTab === '0' ? '/edu/zone/statistics/unit/list/export' : '/edu/zone/statistics/teacher/list/export'
    const res = await API.post(url, data, {
      responseType: 'arraybuffer',
      timeout: 0
    })
    return res
  },
  // 获取作品总数
  async dataGraphGetWorkCount ({ state }, payload) {
    const res = await API.post(`/edu/zone/statistics/work/count`, payload)
    return res
  },
  // 查看开课详情
  async dataGraphGetStartCourseDetail ({ state, commit }, id) {
    const res = await API.post(`/edu/zone/statistics/unit/${id}/package`)
    return res
  },
  // 区域活跃度柱状图
  async getCityActive ({ state, commit }) {
    const res = await API.post(`/edu/zone/statistics/rank/area`, state.activeArea)
    commit('setState', {
      module: 'dataGraph',
      key: 'cityActiveCharts',
      value: res.data
    })
  },
  // 活跃学校前10
  async getActiveSchool ({ state, commit }) {
    commit('setState', {
      module: 'dataGraph',
      key: 'activeSchoolLoading',
      value: true
    })
    const res = await API.post(`/edu/zone/statistics/rank/school`, state.activeArea)
    commit('setState', {
      module: 'dataGraph',
      key: 'activeSchool',
      value: res.data
    })
    commit('setState', {
      module: 'dataGraph',
      key: 'activeSchoolLoading',
      value: false
    })
  },
  // 活跃学生前50
  async getActiveStudent ({ state, commit }) {
    commit('setState', {
      module: 'dataGraph',
      key: 'activeStudentLoading',
      value: true
    })
    const res = await API.post(`/edu/zone/statistics/rank/student`, state.activeArea)
    commit('setState', {
      module: 'dataGraph',
      key: 'activeStudent',
      value: res.data
    })
    commit('setState', {
      module: 'dataGraph',
      key: 'activeStudentLoading',
      value: false
    })
  },
  // 活跃老师前10
  async getActiveTeacher ({ state, commit }) {
    commit('setState', {
      module: 'dataGraph',
      key: 'activeTeacherLoading',
      value: true
    })
    const res = await API.post(`/edu/zone/statistics/rank/teacher`, state.activeArea)
    commit('setState', {
      module: 'dataGraph',
      key: 'activeTeacher',
      value: res.data
    })
    commit('setState', {
      module: 'dataGraph',
      key: 'activeTeacherLoading',
      value: false
    })
  },
  // 优秀作品前50
  async getGoodWork ({ state, commit }) {
    commit('setState', {
      module: 'dataGraph',
      key: 'goodWorkLoading',
      value: true
    })
    const res = await API.post(`/edu/zone/statistics/rank/work`, state.activeArea)
    commit('setState', {
      module: 'dataGraph',
      key: 'goodWork',
      value: res.data
    })
    commit('setState', {
      module: 'dataGraph',
      key: 'goodWorkLoading',
      value: false
    })
  }
}

const mutations = {
  dataGraphTableInit (state) {
    state.page = 1
    state.limit = 10
    state.schoolName = ''
    state.teacherName = ''
    state.area = []
    state.created_at_from = null
    state.created_at_to = null
    state.sort_type = ''
  },
  dataGraphSchoolTableInit (state) {
    state.schoolId = ''
  },
  secondScreenInit (state) {
    state.activeSchool = []
    state.activeTeacher = []
    state.activeStudent = []
    state.goodWork = []
  }
}

export default {
  state,
  actions,
  mutations
}
